import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import GS from "@root/ts/GlobalSetting";
import ViewportRoot, { getViewportName } from "@root/ts/sframe/ViewportRoot";

const MY_HEIGHT = 300;

export default class IndexBonus extends ComponentBase
{
  constructor(elem: ComponentElem)
  {
    super(elem);

    ViewportRoot.emitter.addListener("updated", () =>
    {
      if (getViewportName() !== "mobile") {
        let scale = ViewportRoot.width / GS.MAX_WIDTH,
        maxScale = 1,
        minScale = GS.SCROLL_WIDTH / GS.MAX_WIDTH;

        if(scale > maxScale) scale = maxScale;
        if(scale < minScale) scale = minScale;

        this.$root.css({
          "transform": scale >= 1 ? "" : `scale(${scale})`,
          "height": scale >= 1 ? "" : scale * MY_HEIGHT + "px"
        });
      }
      else {
        this.$root.css({
          "transform": "",
          "height": ""
        });
      }
    });
  }
}